"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _uiKit = require("@devsta/ui-kit");

var _onEnterPressed = _interopRequireDefault(require("@devsta/on-enter-pressed"));

var _Votes = _interopRequireDefault(require("../Votes"));

require("./_post-list-item.scss");

var _Creator = _interopRequireDefault(require("../Creator/Creator"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function handleFavourite(onToggleFavourite) {
  return function (e) {
    if (!onToggleFavourite) {
      return;
    }

    e.stopPropagation();
    onToggleFavourite();
  };
}

function PostListItem(props) {
  var post = props.post,
      onToggleFavourite = props.onToggleFavourite,
      onReportOpen = props.onReportOpen;
  var title = post.title,
      createdByUser = post.createdByUser,
      isFavourited = post.isFavourited,
      createdAt = post.createdAt;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_uiKit.Icon, {
    className: "post-list-item__favourite",
    name: "".concat(isFavourited ? 'favfull' : 'favempty'),
    hoverColor: "".concat(isFavourited ? 'russian' : 'redApple'),
    size: 25,
    color: "".concat(isFavourited ? 'russian' : 'redApple'),
    onClick: handleFavourite(onToggleFavourite)
  }), _react.default.createElement("div", {
    className: "post-list-item__body"
  }, _react.default.createElement("div", {
    className: "post-list-item__body__text"
  }, _react.default.createElement("div", {
    className: "post-list-item__body__text__title"
  }, _react.default.createElement(_uiKit.Text, {
    heading4: true,
    ellipsisOverflow: true
  }, title)), _react.default.createElement("div", {
    className: "post-list-item__body__text__creator"
  }, _react.default.createElement(_Creator.default, {
    creator: createdByUser,
    imageSize: 25,
    placeholderTextSize: 8,
    fontSize: 12
  }), _react.default.createElement(_uiKit.Text, {
    timestamp: true
  }, (0, _moment.default)(createdAt).format('DD MMM YYYY')))), _react.default.createElement(_uiKit.ActionPopup, {
    options: [{
      label: 'Report',
      action: handleFavourite(onReportOpen),
      isRed: true
    }]
  })));
}

var _default = PostListItem;
exports.default = _default;